import { css } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import Blocks from '@/src/cms/components/CMSPage/CorePage/Blocks';
import HeroContent from '@/src/cms/components/CMSPage/CorePage/HeroContent';
import DesignPage from '@/src/cms/models/DesignPage';
import EmploymentTable from '@/src/employment/components/EmploymentTable';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const style = {
  notice: css`
    font-size: 1.6rem;
    text-align: center;
  `,
};

const EmploymentOpportunities = props => {
  const { pagedata, messageData = {} } = props;
  const [Opportunities, setOpportunities] = useState([]);
  const [designPageData, setPageData] = useState(pagedata);

  useEffect(() => {
    const fetchPageData = async () => {
      const pageResponse = await request({
        url: `cms/designpage`,
        params: {
          alias: 'employment',
        },
      });
      if (pageResponse.data?.DateLastUpdated !== pagedata?.DateLastUpdated) {
        setPageData(pageResponse.data);
      }
      const response = await request({
        url: `employment/opportunities`,
        method: 'POST',
        params: {
          active: 'Y',
        },
        data: {
          SortField: 'TITLE',
          SortOrder: 'DESC',
        },
      });
      const { data } = response;
      setOpportunities(data?.Jobs || []);
    };
    fetchPageData();
  }, []);

  const page = new DesignPage({ ...designPageData, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="510" pageType="core" />
      <HeroContent
        heroData={{
          ...page,
        }}
      />
      {page.Blocks.map(b => (
        <Blocks key={b} blockData={page.entities.Blocks[b]} entities={page.entities} />
      ))}
      <Section bgColor="gray">
        <Container>
          {Opportunities.length > 0 && <EmploymentTable data={Opportunities} />}
          {!Opportunities.length > 0 && <div css={style.notice}>No positions available</div>}
        </Container>
      </Section>
      <WebLogImage path="/about/apcia-careers" pagedata={designPageData} />
    </Layout>
  );
};

export async function getStaticProps() {
  const pageResponse = await request({
    url: `cms/designpage`,
    params: {
      alias: 'employment',
    },
  });

  return {
    props: { pagedata: pageResponse.data },
  };
}

export default EmploymentOpportunities;
